module.exports = __webpack_public_path__ + "img/emoIcon.a2f15d1e.svg";